export const floatingMenu = {
  floatingMenuMenu: "Spyskaart",
  floatingMenuHome: "Tuis",
  floatingMenuGames: "Speletjies",
  floatingMenuSlots: "Slots",
  floatingMenuSports: "Sport",
  floatingMenuLottery: "Lotery",
  floatingMenuCasino: "Casino",
  floatingMenuFeed: "Stroom",
  floatingMenuBingo: "Bingo",
  floatingMenuToPlay: "Speel",
  floatingMenuCategories: "Kategorieë",
  floatingMenuSeeAllGames: "Gaan na alle speletjies",
  floatingMenuSeeAllSports: "Gaan na alle sport",
};
